import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import FileUploadIcon from "@mui/icons-material/FileUpload";
// import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

function AddedGuardSucce() {
  const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/Guards")}
              />{" "}
              Add Guard
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Guard Details</div>
            <div className="addAgencyMain">
              <Grid container spacing={3}>
                <div className="addSpotsOutBt AssignDutyBt">
                  <Button
                    className="addSpotsBt"
                    onClick={() => navigate("/Agencies")}
                  >
                    Add Guards Through Agency
                  </Button>
                </div>
                <Grid item xs={12} md={12}>
                  <span className="successfullyMsg">
                    <CheckCircleOutlineIcon />
                    Mile Dormon is added successfully.
                  </span>
                </Grid>
                <Grid item xs={12} md={12}>
                  <div className="IndependentGuardsList">
                    <div className="IndependentGuardsHead">kkk</div>
                  </div>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Button
                    className="addBt"
                    onClick={() => navigate("/AddedGuardSucce")}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default AddedGuardSucce;
